import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_BEGIN,
  MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_FAILURE,
  MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function fetchSubstitutionsData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    /*const pageIndex = args.pageIndex || 1
    const pageSize = args.pageSize || 10
    if(args.isPageChg) {
      let totalData = JSON.parse(localStorage.getItem("subsData"))
      if(totalData && totalData.data) {
        totalData.data = totalData.data.slice((pageIndex - 1) * 10, (pageIndex - 1) * 10 + pageSize)
        dispatch({
          type: MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_SUCCESS,
          data: totalData,
        });
        return
      }
    }*/
    dispatch({
      type: MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "descend",
          sortedBy: "nationalId",  //defect:COT-5369,change default order field to nationalId as same as this in legacy system
        }
      }
      // delete conditions.pageIndex
      // delete conditions.pageSize
      const doRequest = axios.post(`${API_REQUEST_URL}/getSubstitutionsData`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          // localStorage.setItem("subsData", JSON.stringify(data))
          // data.data = data.data.slice((pageIndex - 1) * 10, (pageIndex - 1) * 10 + pageSize)
          dispatch({
            type: MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSubstitutionsDataError() {
  return {
    type: MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_DISMISS_ERROR,
  };
}

export function useFetchSubstitutionsData() {
  const dispatch = useDispatch();

  const { substitutionsData, fetchSubstitutionsDataPending, fetchSubstitutionsDataError } = useSelector(
    state => ({
      substitutionsData: state.manageSubs.substitutionsData,
      fetchSubstitutionsDataPending: state.manageSubs.fetchSubstitutionsDataPending,
      fetchSubstitutionsDataError: state.manageSubs.fetchSubstitutionsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSubstitutionsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSubstitutionsDataError());
  }, [dispatch]);

  return {
    substitutionsData,
    fetchSubstitutionsData: boundAction,
    fetchSubstitutionsDataPending,
    fetchSubstitutionsDataError,
    dismissFetchSubstitutionsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSubstitutionsDataPending: true,
        fetchSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        substitutionsData: action.data,
        fetchSubstitutionsDataPending: false,
        fetchSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSubstitutionsDataPending: false,
        fetchSubstitutionsDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_SUBSTITUTIONS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSubstitutionsDataError: null,
      };

    default:
      return state;
  }
}
